import { Stack, Typography } from '@mui/material'
import { COLORS } from '../../../styles/variables'
import { NotificationDecisionStatus, type DecisionStatus } from './NotificationDecisionStatus'

type Props = {
  status: DecisionStatus
}

export function NotificationExecutedLine({ status }: Props) {
  return (
    <Stack direction="row" gap={0.5} alignItems="center" flexWrap="wrap" sx={{ pt: 1, minWidth: 0 }}>
      <Typography variant="black-14-normal" component="span" sx={{ color: COLORS.SMOKEY_GREY }}>
        Исполнено:
      </Typography>
      <NotificationDecisionStatus status={status} />
    </Stack>
  )
}
